module.exports = __webpack_public_path__ + "static/img/qualifications_row_16.21412c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_16.png
// module id = 0c9j
// module chunks = 1